import { AutoTask } from '../../../../shared/types/autoTask.ts';
import { CombinedFixes, FixMachineRow } from './autoTaskRow.ts';
import { getEquipmentParts } from './getEquipmentParts.ts';

// Groups machines being fixed so the table preview and dialog use the same duration order.
export function combineFixTasks(tasks: AutoTask[]): CombinedFixes | null {
    if (tasks.length === 0) {
        return null;
    }

    const machines: FixMachineRow[] = tasks.map((task) => {
        const { coordinates, name } = getEquipmentParts(task);
        return {
            equipment: task.equipment,
            coordinates,
            name: name || task.equipment,
            duration: Math.max(Date.now() - +task.targetTime, 0),
            isInOperate: task.isInOperate === true,
        };
    });
    machines.sort((left, right) => left.duration - right.duration);

    const previewLimit = 5;
    const preview = machines.slice(0, previewLimit);
    const remainder = machines.length - preview.length;
    return {
        kind: 'fixSummary',
        tasks: machines,
        preview,
        remainder,
        highlightClass: '',
    };
}
